import { isDigit } from 'ldash';
const deleteNonNumericId = ({ tabname, id })=>tabname !== 'stats' && !isDigit(id) ? {
        request: {
            id: null
        }
    } : {};
const ADMIN_QS = 'g:admin,g:qs';
export const tree = {
    tabs: {
        stats: {
            acl: ADMIN_QS,
            datatype: [
                10,
                1,
                2,
                0
            ],
            tabGroup: 'overview',
            parts: [
                'StatsTables'
            ],
            customizeRouting: deleteNonNumericId,
            order: 98,
            minorTabGroup: 'statistic',
            label: 'Bestand'
        },
        dstats: {
            acl: ADMIN_QS,
            datatype: [
                10
            ],
            tabGroup: 'overview',
            parts: [
                'StatsDomainTable'
            ],
            customizeRouting: deleteNonNumericId,
            order: 99,
            minorTabGroup: 'statistic',
            label: 'Domains'
        },
        plots: {
            acl: ADMIN_QS,
            datatype: [
                10
            ],
            tabGroup: 'overview',
            parts: [
                'StatsPlots'
            ],
            order: 100,
            minorTabGroup: 'statistic'
        }
    }
};
